import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { ajouteReservation, suprimerReservation } from "../Redux/actions/actionReservation";
import { suprimerOffre } from "../Redux/actions/actionOffre";
import Select from 'react-select';
import NavBar from '../components/NavBar';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";
import { toast } from 'react-toastify';
import '../Css/reserverSansCritere.css';
import db from '../db';

const ReserverSansCritere = () => {
    let location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const { idRestaurant } = useParams();
    const offre = useSelector((state) => state.offre);

    const [datePrise, setDatePrise] = useState('');
    const [repasprise, setRepasPrise] = useState('');
    const [timePrise, setTimePrise] = useState('');
    const [jourPrise, setJourprise] = useState('');
    const [nombrePersonnePrise, setNombrePersonnePrise] = useState('');

    const [event, setEvent] = useState([]);
    const [repasPersonne, setRepasPersonne] = useState('');
    const [nombreParJour, setNombreParJour] = useState('');
    const [nombre, setNombre] = useState([]);

    const [test,setTest] = useState([]);

    const [activeOffre, setActiveOffre] = useState(false);

    
  useEffect(() => {
    const fetchAndSetData = async()=> {
    try {
      const donner = await db.monTableau.toArray();
      if (donner.length > 0) {
        setTest(donner.find((el) => el.id === parseInt(idRestaurant)));
        console.log("Donner dans dexi=>",donner);
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des données depuis Dexie :', error);
    }
  };
  fetchAndSetData();
  }, [dispatch,idRestaurant]);
  
    const petitDejeuner = test?.informations?.find((item) => item.service === "petitDejeuner");
    const dejeuner = test?.informations?.find((item) => item.service === "dejeuner");
    const diner = test?.informations?.find((item) => item.service === "diner");

    const formatSingle = (date) => {
        if (parseInt(date) < 10) {
            return "0" + date;
        } else {
            return date;
        }
    }

    useEffect(() => {
        test?.fermetureCongers?.forEach((item) => {
            setEvent((prev) => [...prev, { title: 'Fermeture', start: new Date(item.du).getFullYear() + "-" + formatSingle(parseInt(new Date(item.du).getMonth() + 1)) + "-" + formatSingle(new Date(item.du).getDate()), end: new Date(item.au).getFullYear() + "-" + formatSingle(parseInt(new Date(item.au).getMonth() + 1)) + "-" + formatSingle(parseInt(new Date(item.au).getDate() + 1)), backgroundColor: 'grey', display: 'background' }])
        });
    }, [test?.fermetureCongers]);


    const handleDateClick = (arg) => {
        setDatePrise("");
        setRepasPrise("");
        setJourprise("");
        setTimePrise("");
        setNombre([]);
        setNombreParJour("");
        setRepasPersonne("");
        setNombrePersonnePrise("");

        if (test?.fermetureCongers?.length !== 0) {
            var BreakException = {};
            try {
                test?.fermetureCongers?.forEach((item) => {
                    var du = new Date(item.du).getFullYear() + "-" + formatSingle(parseInt(new Date(item.du).getMonth() + 1)) + "-" + formatSingle(new Date(item.du).getDate());
                    var au = new Date(item.au).getFullYear() + "-" + formatSingle(parseInt(new Date(item.au).getMonth() + 1)) + "-" + formatSingle(new Date(item.au).getDate());
                    if (arg.dateStr < du || arg.dateStr > au) {
                        setDatePrise(arg.dateStr);
                        const stringDate = new Date(arg.dateStr).toLocaleDateString('fr-FR', { weekday: "long" });
                        setJourprise(stringDate);

                    } else {
                        toast.warning("Fermeture du resto");
                        setDatePrise("");
                        setJourprise("");
                        setRepasPrise("");
                        setTimePrise("");
                        setNombre([]);
                        setNombreParJour("");
                        setRepasPersonne("");
                        setNombrePersonnePrise("");
                    }
                });
            } catch (e) {
                if (e !== BreakException) throw e;
            }
        } else {
            setDatePrise(arg.dateStr);
            const stringDate = new Date(arg.dateStr).toLocaleDateString('fr-FR', { weekday: "long" });
            setJourprise(stringDate);
        }

    }


    const handleTimesOffre = (repas, time) => {
        setActiveOffre(true);

        if (repas === "petitDejeuner") {
            if (offre.libelle === "Promotion de -50%") {
                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "petitDejeuner" && el.promotion === "promo50");

                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }

                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -50% ne dispose pas de petit dejeuner`);
                }





            } else if (offre.libelle === "Promotion de -40%") {

                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "petitDejeuner" && el.promotion === "promo40");

                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -40% ne dispose pas de petit dejeuner`);
                }

            }





            else if (offre.libelle === "Promotion de -30%") {

                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "petitDejeuner" && el.promotion === "promo30");

                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');

                    toast.warning(`La promotion de -30% ne dispose pas de petit dejeuner`);
                }





            } else if (offre.libelle === "Promotion de -20%") {

                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "petitDejeuner" && el.promotion === "promo20");

                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -20% ne dispose pas de petit dejeuner`);
                }




            } else if (offre.libelle === "Promotion de -10%") {

                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "petitDejeuner" && el.promotion === "promo10");

                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setRepasPrise("Petit dejeuner");
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -10% ne dispose pas de petit dejeuner`);
                }





            } else {
                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "petitDejeuner" && el.promotion === "special");

                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Petit dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion menue spécial ne dispose pas de petit dejeuner`);
                }



            }


            // SANS OFFRE PETIT DEJEUNER +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


        } else if (repas === "dejeuner") {

            if (offre.libelle === "Promotion de -50%") {
                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "dejeuner" && el.promotion === "promo50");


                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -50% ne dispose pas de dejeuner`);
                }


            } else if (offre.libelle === "Promotion de -40%") {

                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "dejeuner" && el.promotion === "promo40");

                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        setNombre([]);
                        setNombrePersonnePrise("");
                        if (nombreRepas.vendredi !== "") {
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -40% ne dispose pas de dejeuner`);
                }
            }
            else if (offre.libelle === "Promotion de -30%") {

                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "dejeuner" && el.promotion === "promo30");

                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -30% ne dispose pas de dejeuner`);
                }

            } else if (offre.libelle === "Promotion de -20%") {

                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "dejeuner" && el.promotion === "promo20");
                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -20% ne dispose pas de dejeuner`);
                }

            } else if (offre.libelle === "Promotion de -10%") {

                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "dejeuner" && el.promotion === "promo10");

                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -10% ne dispose pas de dejeuner`);
                }

            } else {
                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "dejeuner" && el.promotion === "special");

                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Dejeuner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion menu spécial ne dispose pas de  dejeuner`);
                }
            }



        } else {

            if (offre.libelle === "Promotion de -50%") {
                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "diner" && el.promotion === "promo50");


                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -50% ne dispose pas de diner`);
                }

            } else if (offre.libelle === "Promotion de -40%") {

                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "diner" && el.promotion === "promo40");


                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -40% ne dispose pas de diner`);
                }
            }
            else if (offre.libelle === "Promotion de -30%") {

                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "diner" && el.promotion === "promo30");


                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -30% ne dispose pas de diner`);
                }

            } else if (offre.libelle === "Promotion de -20%") {

                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "diner" && el.promotion === "promo20");


                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -20% ne dispose pas de diner`);
                }

            } else if (offre.libelle === "Promotion de -10%") {

                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "diner" && el.promotion === "promo10");


                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion de -10% ne dispose pas de diner`);
                }

            } else {
                const nombreRepas = test?.parametragePromotions?.find((el) => el.service === "diner" && el.promotion === "special");


                if (nombreRepas) {
                    if (jourPrise === "lundi") {
                        if (nombreRepas.lundi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.lundi);
                            if (parseInt(nombreRepas.lundi) > 10) {
                                [...Array(parseInt(nombreRepas.lundi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour lundi");
                        }

                    } else if (jourPrise === "mardi") {
                        if (nombreRepas.mardi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mardi);
                            if (parseInt(nombreRepas.mardi) > 10) {
                                [...Array(parseInt(nombreRepas.mardi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mardi");
                        }
                    } else if (jourPrise === "mercredi") {
                        if (nombreRepas.mercredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.mercredi);
                            if (parseInt(nombreRepas.mercredi) > 10) {
                                [...Array(parseInt(nombreRepas.mercredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour mercredi");
                        }
                    } else if (jourPrise === "jeudi") {
                        if (nombreRepas.jeudi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.jeudi);
                            if (parseInt(nombreRepas.jeudi) > 10) {
                                [...Array(parseInt(nombreRepas.jeudi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour jeudi");
                        }

                    } else if (jourPrise === "vendredi") {
                        if (nombreRepas.vendredi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.vendredi);
                            if (parseInt(nombreRepas.vendredi) > 10) {
                                [...Array(parseInt(nombreRepas.vendredi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour vendredi");
                        }

                    } else if (jourPrise === "samedi") {
                        if (nombreRepas.samedi !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.samedi);
                            if (parseInt(nombreRepas.samedi) > 10) {
                                [...Array(parseInt(nombreRepas.samedi))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour samedi");
                        }

                    } else {

                        if (nombreRepas.dimanche !== "") {
                            setNombre([]);
                            setNombrePersonnePrise("");
                            setRepasPrise("Diner");
                            setRepasPersonne(repas);
                            setTimePrise(time);
                            setNombreParJour(nombreRepas.dimanche);
                            if (parseInt(nombreRepas.dimanche) > 10) {
                                [...Array(parseInt(nombreRepas.dimanche))]?.map((e, i)=> {
                                    if (i + 1 > 10) {
                                        return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                                    }
                                    return null;
                                })
                            }
                        } else {
                            setDatePrise('');
                            setRepasPrise('');
                            setTimePrise('');
                            setJourprise('');
                            setNombre([]);
                            setNombrePersonnePrise("");
                            toast.warning("Ce menu n'est pas disponible pour dimanche");
                        }
                    }
                } else {
                    setRepasPrise('');
                    setTimePrise('');
                    toast.warning(`La promotion menu spécial ne dispose pas de diner`);
                }
            }


            // SANS OFFRE DINER +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

        }
    }





    const handleTimes = (repas, time) => {

        setActiveOffre(false);

        if (repas === "petitDejeuner") {

            if (jourPrise === "lundi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "petitDejeuner");
                if (nombrerRepas.lundi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Petit dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.lundi);
                    if (parseInt(nombrerRepas.lundi) > 10) {
                        [...Array(parseInt(nombrerRepas.lundi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour lundi");
                }

            } else if (jourPrise === "mardi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "petitDejeuner");

                if (nombrerRepas.mardi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Petit dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.mardi);
                    if (parseInt(nombrerRepas.mardi) > 10) {
                        [...Array(parseInt(nombrerRepas.mardi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour mardi");
                }

            } else if (jourPrise === "mercredi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "petitDejeuner");
                if (nombrerRepas.mercredi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Petit dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.mercredi);
                    if (parseInt(nombrerRepas.mercredi) > 10) {
                        [...Array(parseInt(nombrerRepas.mercredi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {

                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour mercredi");
                }

            } else if (jourPrise === "jeudi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "petitDejeuner");
                if (nombrerRepas.jeudi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Petit dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.jeudi);
                    if (parseInt(nombrerRepas.jeudi) > 10) {
                        [...Array(parseInt(nombrerRepas.jeudi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour jeudi");
                }

            } else if (jourPrise === "vendredi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "petitDejeuner");
                if (nombrerRepas.vendredi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Petit dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.vendredi);
                    if (parseInt(nombrerRepas.vendredi) > 10) {
                        [...Array(parseInt(nombrerRepas.vendredi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour vendredi");
                }

            } else if (jourPrise === "samedi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "petitDejeuner");
                if (nombrerRepas.samedi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Petit dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.samedi);
                    if (parseInt(nombrerRepas.samedi) > 10) {
                        [...Array(parseInt(nombrerRepas.samedi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour samedi");
                }

            } else {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "petitDejeuner");

                if (nombrerRepas.dimanche !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Petit dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.dimanche);
                    if (parseInt(nombrerRepas.dimanche) > 10) {
                        [...Array(parseInt(nombrerRepas.dimanche))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour dimanche");
                }

            }



            // FIN PETIT DEJEUNER +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


            // DEJEUNER +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

        } else if (repas === "dejeuner") {

            if (jourPrise === "lundi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "dejeuner");
                if (nombrerRepas.lundi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.lundi);
                    if (parseInt(nombrerRepas.lundi) > 10) {
                        [...Array(parseInt(nombrerRepas.lundi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour lundi");
                }

            } else if (jourPrise === "mardi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "dejeuner");

                if (nombrerRepas.mardi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.mardi);
                    if (parseInt(nombrerRepas.mardi) > 10) {
                        [...Array(parseInt(nombrerRepas.mardi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour mardi");
                }

            } else if (jourPrise === "mercredi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "dejeuner");
                if (nombrerRepas.mercredi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.mercredi);
                    if (parseInt(nombrerRepas.mercredi) > 10) {
                        [...Array(parseInt(nombrerRepas.mercredi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {

                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour mercredi");
                }

            } else if (jourPrise === "jeudi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "dejeuner");
                if (nombrerRepas.jeudi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.jeudi);
                    if (parseInt(nombrerRepas.jeudi) > 10) {
                        [...Array(parseInt(nombrerRepas.jeudi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour jeudi");
                }

            } else if (jourPrise === "vendredi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "dejeuner");
                if (nombrerRepas.vendredi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.vendredi);
                    if (parseInt(nombrerRepas.vendredi) > 10) {
                        [...Array(parseInt(nombrerRepas.vendredi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour vendredi");
                }

            } else if (jourPrise === "samedi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "dejeuner");
                if (nombrerRepas.samedi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.samedi);
                    if (parseInt(nombrerRepas.samedi) > 10) {
                        [...Array(parseInt(nombrerRepas.samedi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour samedi");
                }

            } else {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "dejeuner");

                if (nombrerRepas.dimanche !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Dejeuner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.dimanche);
                    if (parseInt(nombrerRepas.dimanche) > 10) {
                        [...Array(parseInt(nombrerRepas.dimanche))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour dimanche");
                }

            }


            // FIN DEJEUNER +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


            // DINER +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

        } else {

            if (jourPrise === "lundi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "diner");
                if (nombrerRepas.lundi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Diner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.lundi);
                    if (parseInt(nombrerRepas.lundi) > 10) {
                        [...Array(parseInt(nombrerRepas.lundi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour lundi");
                }

            } else if (jourPrise === "mardi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "diner");

                if (nombrerRepas.mardi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Diner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.mardi);
                    if (parseInt(nombrerRepas.mardi) > 10) {
                        [...Array(parseInt(nombrerRepas.mardi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour mardi");
                }

            } else if (jourPrise === "mercredi") {
                setNombre([]);
                setNombrePersonnePrise("");
                setRepasPrise("Diner");
                setRepasPersonne(repas);
                setTimePrise(time);
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "diner");
                if (nombrerRepas.mercredi !== "") {
                    setNombreParJour(nombrerRepas.mercredi);
                    if (parseInt(nombrerRepas.mercredi) > 10) {
                        [...Array(parseInt(nombrerRepas.mercredi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {

                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour mercredi");
                }

            } else if (jourPrise === "jeudi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "diner");
                if (nombrerRepas.jeudi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Diner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.jeudi);
                    if (parseInt(nombrerRepas.jeudi) > 10) {
                        [...Array(parseInt(nombrerRepas.jeudi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour jeudi");
                }

            } else if (jourPrise === "vendredi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "diner");
                if (nombrerRepas.vendredi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Diner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.vendredi);
                    if (parseInt(nombrerRepas.vendredi) > 10) {
                        [...Array(parseInt(nombrerRepas.vendredi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour vendredi");
                }

            } else if (jourPrise === "samedi") {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "diner");
                if (nombrerRepas.samedi !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Diner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.samedi);
                    if (parseInt(nombrerRepas.samedi) > 10) {
                        [...Array(parseInt(nombrerRepas.samedi))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour samedi");
                }

            } else {
                const nombrerRepas = test?.sansOffres?.find((el) => el.service === "diner");

                if (nombrerRepas.dimanche !== "") {
                    setNombre([]);
                    setNombrePersonnePrise("");
                    setRepasPrise("Diner");
                    setRepasPersonne(repas);
                    setTimePrise(time);
                    setNombreParJour(nombrerRepas.dimanche);
                    if (parseInt(nombrerRepas.dimanche) > 10) {
                        [...Array(parseInt(nombrerRepas.dimanche))]?.map((e, i)=> {
                            if (i + 1 > 10) {
                                return setNombre((prev) => [...prev, { value: i + 1, label: i + 1 }]);
                            }
                            return null;
                        })
                    }
                } else {
                    setDatePrise('');
                    setRepasPrise('');
                    setTimePrise('');
                    setJourprise('');
                    setNombre([]);
                    setNombrePersonnePrise("");
                    toast.warning("Ce menu n'est pas disponible pour dimanche");
                }

            }

            // FIN DINER +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++




        }

    }





    const petitDejeunerViewOffre = () => {
        var startHours = new Date(petitDejeuner.heureDebut).getUTCHours();
        var endHours = new Date(petitDejeuner.heureFin).getUTCHours();
        const start = new Date();
        start.setHours(startHours, 0, 0);
        const times = [];
        const end = new Date();
        end.setHours(endHours, 0, 0);


        while (start <= end) {
            console.log(start.toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
            times.push(start.toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
            start.setMinutes(start.getMinutes() + 30);
        }
        console.log("times PetitDejeuner", times);
        return (
            times.map((item, i) => {
                return (<div className="form-check form-check-inline" key={i}>
                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id={"inlineCheckboxPetitDejeuner" + item} onChange={() => handleTimesOffre("petitDejeuner", item)} defaultValue={"optionPetitDejeuner" + item} />
                    <label className="form-check-label" htmlFor={"inlineCheckboxPetitDejeuner" + item}>{item}</label>
                </div>)
            })
        )


    }



    const petitDejeunerView = () => {
        var startHours = new Date(petitDejeuner.heureDebut).getUTCHours();
        var endHours = new Date(petitDejeuner.heureFin).getUTCHours();
        const start = new Date();
        start.setHours(startHours, 0, 0);
        const times = [];
        const end = new Date();
        end.setHours(endHours, 0, 0);


        while (start <= end) {
            console.log(start.toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
            times.push(start.toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
            start.setMinutes(start.getMinutes() + 30);
        }
        console.log("times PetitDejeuner", times);
        return (
            times.map((item, i) => {
                return (<div className="form-check form-check-inline" key={i}>
                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id={"inlineCheckboxPetitDejeuner" + item} onChange={() => handleTimes("petitDejeuner", item)} defaultValue={"optionPetitDejeuner" + item} />
                    <label className="form-check-label" htmlFor={"inlineCheckboxPetitDejeuner" + item}>{item}</label>
                </div>)
            })
        )


    }



    const dejeunerViewOffre = () => {
        var startHours = new Date(dejeuner.heureDebut).getUTCHours();
        var endHours = new Date(dejeuner.heureFin).getUTCHours();
        const start = new Date();
        start.setHours(startHours, 0, 0);
        const times = [];
        const end = new Date();
        end.setHours(endHours, 0, 0);


        while (start <= end) {
            console.log(start.toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
            times.push(start.toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
            start.setMinutes(start.getMinutes() + 30);
        }
        console.log("times dejeuner", times);
        return (
            times.map((item, i) => {
                return (<div className="form-check form-check-inline" key={i}>
                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id={"inlineCheckboxDejeuner" + item} onChange={() => handleTimesOffre("dejeuner", item)} defaultValue={"optionDejeuner" + item} />
                    <label className="form-check-label" htmlFor={"inlineCheckboxDejeuner" + item}>{item}</label>
                </div>)
            })
        )
    }




    const dejeunerView = () => {
        var startHours = new Date(dejeuner.heureDebut).getUTCHours();
        var endHours = new Date(dejeuner.heureFin).getUTCHours();
        const start = new Date();
        start.setHours(startHours, 0, 0);
        const times = [];
        const end = new Date();
        end.setHours(endHours, 0, 0);


        while (start <= end) {
            console.log(start.toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
            times.push(start.toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
            start.setMinutes(start.getMinutes() + 30);
        }
        console.log("times dejeuner", times);
        return (
            times.map((item, i) => {
                return (<div className="form-check form-check-inline" key={i}>
                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id={"inlineCheckboxDejeuner" + item} onChange={() => handleTimes("dejeuner", item)} defaultValue={"optionDejeuner" + item} />
                    <label className="form-check-label" htmlFor={"inlineCheckboxDejeuner" + item}>{item}</label>
                </div>)
            })
        )
    }



    const dinerViewOffre = () => {
        var startHours = new Date(diner.heureDebut).getUTCHours();
        var endHours = new Date(diner.heureFin).getUTCHours();
        const start = new Date();
        start.setHours(startHours, 0, 0);
        const times = [];
        const end = new Date();
        end.setHours(endHours, 0, 0);


        while (start <= end) {
            console.log(start.toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
            times.push(start.toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
            start.setMinutes(start.getMinutes() + 30);
        }
        console.log("times diner", times);
        return (
            times?.map((item, i) => {
                return (<div className="form-check form-check-inline" key={i}>
                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id={"inlineCheckboxDiner" + item} onChange={() => handleTimesOffre("diner", item)} defaultValue={"optionDiner" + item} />
                    <label className="form-check-label" htmlFor={"inlineCheckboxDiner" + item}>{item}</label>
                </div>)
            })
        )
    }



    const dinerView = () => {
        var startHours = new Date(diner.heureDebut).getUTCHours();
        var endHours = new Date(diner.heureFin).getUTCHours();
        const start = new Date();
        start.setHours(startHours, 0, 0);
        const times = [];
        const end = new Date();
        end.setHours(endHours, 0, 0);
        while (start <= end) {
            console.log(start.toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
            times.push(start.toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
            start.setMinutes(start.getMinutes() + 30);
        }
        return (
            times.map((item, i) => {
                return (<div className="form-check form-check-inline" key={i}>
                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id={"inlineCheckboxDiner" + item} onChange={() => handleTimes("diner", item)} defaultValue={"optionDiner" + item} />
                    <label className="form-check-label" htmlFor={"inlineCheckboxDiner" + item}>{item}</label>
                </div>)
            })
        )
    }






    const OffreNombrePersnne = () => {

        if (jourPrise === "lundi") {



            if (offre.libelle === "Promotion de -50%") {

                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo50");

                console.log("repasvalue", parseInt(repas.lundi));
                return (
                    [...Array(parseInt(repas.lundi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else if (offre.libelle === "Promotion de -40%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo40");

                console.log("repasvalue", parseInt(repas.lundi));
                return (
                    [...Array(parseInt(repas.lundi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -30%") {

                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo30");

                console.log("repasvalue", parseInt(repas.lundi));

                return (
                    [...Array(parseInt(repas.lundi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -20%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo20");
                console.log("repasvalue", parseInt(repas.lundi));
                return (
                    [...Array(parseInt(repas.lundi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -10%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo10");

                console.log("repasvalue", parseInt(repas.lundi));

                return (
                    [...Array(parseInt(repas.lundi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "special");
                console.log("repasvalue", parseInt(repas.lundi));

                return (
                    [...Array(parseInt(repas.lundi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            }




        } else if (jourPrise === "mardi") {



            if (offre.libelle === "Promotion de -50%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo50");

                console.log("repasvalue", parseInt(repas.mardi));
                return (
                    [...Array(parseInt(repas.mardi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )



            } else if (offre.libelle === "Promotion de -40%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo40");

                console.log("repasvalue", parseInt(repas.mardi));


                return (
                    [...Array(parseInt(repas.mardi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -30%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo30");

                console.log("repasvalue", parseInt(repas.mardi));

                return (
                    [...Array(parseInt(repas.mardi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else if (offre.libelle === "Promotion de -20%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo20");
                console.log("repasvalue", parseInt(repas.mardi));


                return (
                    [...Array(parseInt(repas.mardi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -10%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo10");

                console.log("repasvalue", parseInt(repas.mardi));


                return (
                    [...Array(parseInt(repas.mardi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "special");

                console.log("repasvalue", parseInt(repas.mardi));

                return (
                    [...Array(parseInt(repas.mardi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            }



        } else if (jourPrise === "mercredi") {



            if (offre.libelle === "Promotion de -50%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo50");

                console.log("repasvalue", parseInt(repas.mercredi));

                return (
                    [...Array(parseInt(repas.mercredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )



            } else if (offre.libelle === "Promotion de -40%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo40");

                console.log("repasvalue", parseInt(repas.mercredi));
                return (
                    [...Array(parseInt(repas.mercredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else if (offre.libelle === "Promotion de -30%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo30");

                console.log("repasvalue", parseInt(repas.mercredi));

                return (
                    [...Array(parseInt(repas.mercredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else if (offre.libelle === "Promotion de -20%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo20");
                console.log("repasvalue", parseInt(repas.mercredi));
                return (
                    [...Array(parseInt(repas.mercredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -10%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo10");

                console.log("repasvalue", parseInt(repas.mercredi));



                return (
                    [...Array(parseInt(repas.mercredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "special");
                console.log("repasvalue", parseInt(repas.mercredi));

                return (
                    [...Array(parseInt(repas.mercredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            }




        } else if (jourPrise === "jeudi") {



            if (offre.libelle === "Promotion de -50%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo50");

                console.log("repasvalue", parseInt(repas.jeudi));

                return (
                    [...Array(parseInt(repas.jeudi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -40%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo40");

                console.log("repasvalue", parseInt(repas.jeudi));

                return (
                    [...Array(parseInt(repas.jeudi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else if (offre.libelle === "Promotion de -30%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo30");

                console.log("repasvalue", parseInt(repas.jeudi));

                return (
                    [...Array(parseInt(repas.jeudi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -20%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo20");

                console.log("repasvalue", parseInt(repas.jeudi));


                return (
                    [...Array(parseInt(repas.jeudi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else if (offre.libelle === "Promotion de -10%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo10");

                console.log("repasvalue", parseInt(repas.jeudi));

                return (
                    [...Array(parseInt(repas.jeudi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "special");
                console.log("repasvalue", parseInt(repas.jeudi));

                return (
                    [...Array(parseInt(repas.jeudi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            }



        } else if (jourPrise === "vendredi") {


            if (offre.libelle === "Promotion de -50%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo50");

                console.log("repasvalue", parseInt(repas.vendredi));

                return (
                    [...Array(parseInt(repas.vendredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -40%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo40");
                console.log("repasvalue", parseInt(repas.vendredi));

                return (
                    [...Array(parseInt(repas.vendredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else if (offre.libelle === "Promotion de -30%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo30");

                console.log("repasvalue", parseInt(repas.vendredi));

                return (
                    [...Array(parseInt(repas.vendredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -20%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo20");

                console.log("repasvalue", parseInt(repas.vendredi));


                return (
                    [...Array(parseInt(repas.vendredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else if (offre.libelle === "Promotion de -10%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo10");


                console.log("repasvalue", parseInt(repas.vendredi));


                return (
                    [...Array(parseInt(repas.vendredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "special");

                console.log("repasvalue", parseInt(repas.vendredi));



                return (
                    [...Array(parseInt(repas.vendredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            }

        } else if (jourPrise === "samedi") {

            if (offre.libelle === "Promotion de -50%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo50");

                console.log("repasvalue", parseInt(repas.samedi));

                return (
                    [...Array(parseInt(repas.samedi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -40%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo40");
                console.log("repasvalue", parseInt(repas.samedi));


                return (
                    [...Array(parseInt(repas.samedi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -30%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo30");

                console.log("repasvalue", parseInt(repas.samedi));
                return (
                    [...Array(parseInt(repas.samedi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -20%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo20");

                console.log("repasvalue", parseInt(repas.samedi));
                return (
                    [...Array(parseInt(repas.samedi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else if (offre.libelle === "Promotion de -10%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo10");
                setNombreParJour(repas.samedi);
                console.log("repasvalue", parseInt(repas.samedi));


                return (
                    [...Array(parseInt(repas.samedi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "special");

                console.log("repasvalue", parseInt(repas.samedi));

                return (
                    [...Array(parseInt(repas.samedi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            }




        } else {



            if (offre.libelle === "Promotion de -50%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo50");
                console.log("repasvalue", parseInt(repas.dimanche));

                return (
                    [...Array(parseInt(repas.dimanche))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -40%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo40");

                console.log("repasvalue", parseInt(repas.dimanche));


                return (
                    [...Array(parseInt(repas.dimanche))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else if (offre.libelle === "Promotion de -30%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo30");
                console.log("repasvalue", parseInt(repas.dimanche));

                return (
                    [...Array(parseInt(repas.dimanche))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            } else if (offre.libelle === "Promotion de -20%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo20");

                console.log("repasvalue", parseInt(repas.dimanche));

                return (
                    [...Array(parseInt(repas.dimanche))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else if (offre.libelle === "Promotion de -10%") {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "promo10");

                console.log("repasvalue", parseInt(repas.dimanche));

                return (
                    [...Array(parseInt(repas.dimanche))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )

            } else {
                const repas = test?.parametragePromotions?.find((el) => el.service === repasPersonne && el.promotion === "special");


                console.log("repasvalue", parseInt(repas.dimanche));

                return (
                    [...Array(parseInt(repas.dimanche))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )


            }


        }


    }


















    const nombrePersonneView = () => {
        if (jourPrise === "lundi") {

            const repas = test?.sansOffres?.find((el) => el.service === repasPersonne);
            if (repas.lundi !== "") {
                return (
                    [...Array(parseInt(repas.lundi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )
            } else {
                toast.warning("Ce menu n'est pas disponible pour lundi");
            }


        } else if (jourPrise === "mardi") {
            const repas = test?.sansOffres?.find((el) => el.service === repasPersonne);
            if (repas.mardi !== "") {
                return (
                    [...Array(parseInt(repas.mardi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )
            } else {
                toast.warning("Ce menu n'est pas disponible pour mardi");
            }


        } else if (jourPrise === "mercredi") {

            const repas = test?.sansOffres?.find((el) => el.service === repasPersonne);
            console.log("repasvalue", parseInt(repas.mercredi));

            if (repas.mercredi !== "") {
                return (
                    [...Array(parseInt(repas.mercredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )
            } else {

                toast.warning("Ce menu n'est pas disponible pour mercredi");
            }

        } else if (jourPrise === "jeudi") {

            const repas = test?.sansOffres?.find((el) => el.service === repasPersonne);
            console.log("repasvalue", parseInt(repas.jeudi));

            if (repas.jeudi !== "") {
                return (
                    [...Array(parseInt(repas.jeudi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )
            } else {
                toast.warning("Ce menu n'est pas disponible pour jeudi");
            }


        } else if (jourPrise === "vendredi") {

            const repas = test?.sansOffres?.find((el) => el.service === repasPersonne);
            console.log("repasvalue", parseInt(repas.vendredi));

            if (repas.vendredi !== "") {
                return (
                    [...Array(parseInt(repas.vendredi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )
            } else {
                toast.warning("Ce menu n'est pas disponible pour vendredi");
            }

        } else if (jourPrise === "samedi") {

            const repas = test?.sansOffres?.find((el) => el.service === repasPersonne);
            console.log("repasvalue", parseInt(repas.samedi));

            if (repas.samedi !== "") {
                return (
                    [...Array(parseInt(repas.samedi))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )
            } else {
                toast.warning("Ce menu n'est pas disponible pour samedi");
            }

        } else {
            const repas = test?.sansOffres?.find((el) => el.service === repasPersonne);
            console.log("repasvalue", parseInt(repas.dimanche));

            if (repas.dimanche !== "") {
                return (
                    [...Array(parseInt(repas.dimanche))]?.map((e, i)=> {
                        if (i + 1 <= 10) {
                            return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" name="inlineRadioOptionsNombrePersonne" onChange={() => setNombrePersonnePrise(i + 1)} id={"inlineCheckbox1" + i} defaultValue={"options" + i} />
                                <label className="form-check-label" htmlFor={"inlineCheckbox1" + i}>{i + 1}</label>
                            </div>)
                        }
                        return null;
                    })
                )
            } else {
                toast.warning("Ce menu n'est pas disponible pour dimanche");
            }

        }

    }


    const formatPersonne = (nombre) => {
        if (nombre > 1) {
            return "pour " + nombre + " personnes";
        } else {
            return "pour " + nombre + " personne";
        }
    }


    const handleResever = () => {
        if (datePrise === "" || timePrise === "" || nombrePersonnePrise === "") {
            toast.warning("Vous devez fournier la date , l'heure et el le nombre de personne");
        } else {
            if (activeOffre === true) {
                const data = { date: datePrise, heure: timePrise, personne: nombrePersonnePrise };
                localStorage.setItem('reservation', JSON.stringify(data));
                dispatch(ajouteReservation(data));
                navigate('/finaliserReservation', { state: { idRestaurant: idRestaurant } });
            } else {
                dispatch(suprimerOffre());
                localStorage.removeItem('offre');
                const data = { date: datePrise, heure: timePrise, personne: nombrePersonnePrise };
                localStorage.setItem('reservation', JSON.stringify(data));
                dispatch(ajouteReservation(data));
                navigate('/finaliserReservation', { state: { idRestaurant: idRestaurant } });
            }

        }
    }

    const handleAnnuler = () => {
        dispatch(suprimerReservation());
        dispatch(suprimerOffre());
        localStorage.removeItem('reservation');
        localStorage.removeItem('offre');
        navigate('/');
    }

    console.log(petitDejeuner);
    console.log(dejeuner);
    console.log(diner);

    console.log("jour Prise", jourPrise);

    console.log("nombre par jour=>", nombreParJour);

    console.log("nombre par jour=>", nombre);


    const libelleFilter = (value) => {
        if (value === "Lundi") {
            return "Lu";
        } else if (value === "Mardi") {
            return "Ma";
        } else if (value === "Mercredi") {
            return "Me";
        } else if (value === "Jeudi") {
            return "Je";
        } else if (value === "Vendredi") {
            return "Ve";
        } else if (value === "Samedi") {
            return "Sa";
        } else {
            return "Di";
        }
    }



    const promotion = () => {
        const existePromo50 = test?.promotions?.find((el) => el.libelle === "Promotion de -50%");
        const existePromo40 = test?.promotions?.find((el) => el.libelle === "Promotion de -40%");
        const existePromo30 = test?.promotions?.find((el) => el.libelle === "Promotion de -30%");
        const existePromo20 = test?.promotions?.find((el) => el.libelle === "Promotion de -20%");
        const existePromo10 = test?.promotions?.find((el) => el.libelle === "Promotion de -10%");
        const existePromoSpecial = test?.promotions?.find((el) => el.libelle === "Promotion : Menu spécial");

        if (existePromo50) {
            return "promo50";
        } else if (existePromo40) {
            return "promo40";
        } else if (existePromo30) {
            return "promo30";
        } else if (existePromo20) {
            return "promo20";
        } else if (existePromo10) {
            return "promo10";
        } else if (existePromoSpecial) {
            return "special";
        }


    }


    const viewPromo = () => {

        let existePetitDejeuner = test?.parametragePromotions?.find((el) => el.promotion === promotion() && el.service === "petitDejeuner");
        let existeDejeuner = test?.parametragePromotions?.find((el) => el.promotion === promotion() && el.service === "dejeuner");
        let existeDiner = test?.parametragePromotions?.find((el) => el.promotion === promotion() && el.service === "diner");

        return (
            <div className='valuePormo'>
                <div className='reserver_creneau'>
                    <h2 className='text-center titre_heure'>Choisissez l'heure avec Offre</h2>

                    {existePetitDejeuner && petitDejeuner.heureDebut !== "" && petitDejeuner.heureFin !== "" && petitDejeuner.capaciter !== "" ?
                        <> <h3 className='mt-2'><i className="fa fa-cutlery"></i>Petit déjeuner</h3>

                            {existePetitDejeuner.lundi !== "" ?
                                <span className='listeJour'>Lu</span>
                                : ''}
                            {existePetitDejeuner.mardi !== "" ?
                                <span className='listeJour'>Ma</span>
                                : ''}
                            {existePetitDejeuner.mercredi !== "" ?
                                <span className='listeJour'>Me</span>
                                : ''}
                            {existePetitDejeuner.jeudi !== "" ?
                                <span className='listeJour'>Jeu</span>
                                : ''}
                            {existePetitDejeuner.vendredi !== "" ?
                                <span className='listeJour'>Ve</span>
                                : ''}
                            {existePetitDejeuner.samedi !== "" ?
                                <span className='listeJour'>Sa</span>
                                : ''}
                            {existePetitDejeuner.dimanche !== "" ?
                                <span className='listeJour'>Di</span>
                                : ''}


                            <div className='creneau_liste'>
                                <div>
                                    {petitDejeunerViewOffre()}
                                </div>
                            </div></> : ''}



                    {existeDejeuner && dejeuner.heureDebut !== "" && dejeuner.heureFin !== "" && dejeuner.capaciter !== "" ?
                        <> <h3 className='mt-2'><i className="fa fa-cutlery"></i>Déjeuner</h3>

                            {existeDejeuner.lundi !== "" ?
                                <span className='listeJour'>Lu</span>
                                : ''}
                            {existeDejeuner.mardi !== "" ?
                                <span className='listeJour'>Ma</span>
                                : ''}
                            {existeDejeuner.mercredi !== "" ?
                                <span className='listeJour'>Me</span>
                                : ''}
                            {existeDejeuner.jeudi !== "" ?
                                <span className='listeJour'>Jeu</span>
                                : ''}
                            {existeDejeuner.vendredi !== "" ?
                                <span className='listeJour'>Ve</span>
                                : ''}
                            {existeDejeuner.samedi !== "" ?
                                <span className='listeJour'>Sa</span>
                                : ''}
                            {existeDejeuner.dimanche !== "" ?
                                <span className='listeJour'>Di</span>
                                : ''}
                            <div className='creneau_liste'>
                                <div>
                                    {dejeunerViewOffre()}
                                </div>

                            </div></>
                        : ''}

                    {existeDiner && diner.heureDebut !== "" && diner.heureFin !== "" && diner.capaciter !== "" ?
                        <><h3 className='mt-2'><i className="fa fa-cutlery"></i>Diner</h3>
                            {existeDiner.lundi !== "" ?
                                <span className='listeJour'>Lu</span>
                                : ''}
                            {existeDiner.mardi !== "" ?
                                <span className='listeJour'>Ma</span>
                                : ''}
                            {existeDiner.mercredi !== "" ?
                                <span className='listeJour'>Me</span>
                                : ''}
                            {existeDiner.jeudi !== "" ?
                                <span className='listeJour'>Jeu</span>
                                : ''}
                            {existeDiner.vendredi !== "" ?
                                <span className='listeJour'>Ve</span>
                                : ''}
                            {existeDiner.samedi !== "" ?
                                <span className='listeJour'>Sa</span>
                                : ''}
                            {existeDiner.dimanche !== "" ?
                                <span className='listeJour'>Di</span>
                                : ''}
                            <div className='creneau_liste'>
                                <div>
                                    {dinerViewOffre()}

                                </div>

                            </div></> : ''}
                </div>
            </div>
        )
    }


    return (
        <div>
            <Helmet>
                <title>Réserver sans critère</title>
                <meta name='description' content='Réserver sans critère' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <header>
                <NavBar />
            </header>
            <div className='reserverSansCritere'>
                <div className='reserverSansCritere_content'>
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3'>
                            <div className='description_astuces'>
                                <div className='astuces_resto'>
                                    <div className='astuces_apropos'>
                                        <div className='astuces_photo'>
                                            <img src={test?.photos ? test?.photos[0]?.basePhoto : ""} alt="avatar restaurant" />
                                        </div>
                                        <div className='astuces_adresse'>
                                            <div className='d-flex justify-content-center flex_titre'>
                                                <span className='nom_resto'>{test.nomRestaurant}</span>
                                            </div>
                                            <div className='d-flex justify-content-center flex_titre'>
                                                <span className='astuces_adresse'>{test.adresse}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='astuces_offre'>
                                    <div className='d-flex justify-content-center'>
                                        <span className='astuces_offreTitre'>Rappel type d’offre sélectionnée</span>
                                    </div>
                                    {
                                        offre.length !== 0 ? <div className='astuces_offreContent'>
                                            <span className='astuces_promo'><i className='fa fa-bullhorn'></i>{offre.libelle}</span>
                                            <div className='astuces_offreCondition'>
                                                <span>Hors menus, hors formules</span>
                                                <ul>
                                                    {offre.horsBoisson === true ?
                                                        <li>Hors boisson</li>
                                                        : ''}

                                                    {offre.pourTout === true ?
                                                        <li>Pour toute commande d’Entrée+Plat ou Plat+Dessert minimum par personne</li>
                                                        : ''}

                                                </ul>
                                            </div>
                                            {datePrise !== "" ?
                                                viewPromo()
                                                : ''}

                                        </div> :
                                            <div className='astuces_offreContent'>
                                                <span className='astuces_promo'><i className='fa fa-bullhorn'></i>Sans offres</span>
                                            </div>
                                    }

                                </div>
                                <div className='astuces'>
                                    <div className='d-flex justify-content-center'>
                                        <span className='astuces_titre'>Réserver en ligne n’a que des avantages</span>
                                    </div>
                                    <div className='astuces_liste'>
                                        <ul>
                                            <li>Le service est accessible à toute heure</li>
                                            <li>Vous recevez une confirmation immédiate par email et SMS</li>
                                            <li>Il est donc inutile d’appeler le restaurant</li>
                                            <li>C’est gratuit !</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9'>
                            <div className='row'>
                                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6'>
                                    <div className='indicatif'>
                                        <h1>Vérification en temps réel de la disponibilité pour vous et vos convives … </h1>
                                        <div className='liste'>
                                            <div className='liste_dispo'>
                                                <div className='color1'></div>
                                                <span>Restaurant disponible</span>
                                            </div>
                                            <div className='liste_nomDispo'>
                                                <div className='color2'></div>
                                                <span>Restaurant fermer</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='reserver_calendar'>
                                        <h2 className='datePrise'>Du {datePrise} {repasprise !== "" ? repasprise + " du " + timePrise : ''} {nombrePersonnePrise !== "" ? formatPersonne(nombrePersonnePrise) : ""} {timePrise !== "" ? activeOffre === true ? "Avec offre" : "Sans offre" : ""}</h2>
                                        <FullCalendar
                                            plugins={[dayGridPlugin, interactionPlugin]}
                                            buttonText={{
                                                today: "Ce mois ci",
                                            }}
                                            firstDay='1'
                                            dateClick={handleDateClick}
                                            events={event}
                                            locale='fr'
                                        />
                                    </div>

                                    <div className='reserver_calendar_responsive'>
                                        <h2 className='datePrise'>Du {datePrise} {repasprise !== "" ? repasprise + " du " + timePrise : ''} {nombrePersonnePrise !== "" ? formatPersonne(nombrePersonnePrise) : ""} </h2>
                                        <FullCalendar
                                            plugins={[dayGridPlugin, interactionPlugin]}
                                            buttonText={{
                                                today: "Ce mois ci",
                                            }}
                                            firstDay='1'
                                            dateClick={handleDateClick}
                                            events={event}
                                            locale='fr'
                                        />
                                    </div>
                                    <div className='d-flex justify-content-center'>
                                        <div className='validationCritere'>
                                            <button className='btn btn_annuler' onClick={handleAnnuler}>Annuler</button>
                                            <button className='btn btn_reserver' onClick={handleResever}>Réserver</button>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6'>
                                    {datePrise !== "" ?
                                        <div className='resulte_reservation'>

                                            <div className='reserver_creneau'>
                                                <h2 className='text-center titre_heure'>Choisissez l'heure Sans offre</h2>

                                                {petitDejeuner.heureDebut !== "" && petitDejeuner.heureFin !== "" && petitDejeuner.capaciter !== "" ?
                                                    <> <h3 className='mt-2'><i className="fa fa-cutlery"></i>Petit déjeuner</h3>
                                                        {petitDejeuner.ouvertures.length !== 0 ?
                                                            <>
                                                                <span className='titreOuverture'>Le</span> {petitDejeuner.ouvertures.map((el, index) => {
                                                                    return (<span className='listeJour' key={index}>{libelleFilter(el.libelle)}</span>)
                                                                })}
                                                            </>
                                                            : ''}
                                                        <div className='creneau_liste'>
                                                            <div>
                                                                {petitDejeunerView()}
                                                            </div>
                                                        </div></> : ''}



                                                {dejeuner.heureDebut !== "" && dejeuner.heureFin !== "" && dejeuner.capaciter !== "" ?
                                                    <> <h3 className='mt-2'><i className="fa fa-cutlery"></i>Déjeuner</h3>
                                                        {dejeuner.ouvertures.length !== 0 ?
                                                            <>
                                                                <span className='titreOuverture'>Le</span> {dejeuner.ouvertures.map((el, index) => {
                                                                    return (<span className='listeJour' key={index}>{libelleFilter(el.libelle)}</span>)
                                                                })}
                                                            </>
                                                            : ''}
                                                        <div className='creneau_liste'>
                                                            <div>
                                                                {dejeunerView()}
                                                            </div>

                                                        </div></>
                                                    : ''}

                                                {diner.heureDebut !== "" && diner.heureFin !== "" && diner.capaciter !== "" ?
                                                    <><h3 className='mt-2'><i className="fa fa-cutlery"></i>Diner</h3>
                                                        {diner.ouvertures.length !== 0 ?
                                                            <>
                                                                <span className='titreOuverture'>Le</span> {diner.ouvertures.map((el, index) => {
                                                                    return (<span className='listeJour' key={index}>{libelleFilter(el.libelle)}</span>)
                                                                })}
                                                            </>
                                                            : ''}
                                                        <div className='creneau_liste'>
                                                            <div>
                                                                {dinerView()}

                                                            </div>

                                                        </div></> : ''}
                                            </div>


                                        </div>
                                        : ''}

                                    {repasprise !== "" ?
                                        <div className='reserver_nbrPersone'>
                                            <h2 className='text-center titre_heure'>Choisissez le nombre de personne</h2>
                                            <h3><i className='fa fa-users'></i>Nombre de personne [ 1 à 10 ]</h3>
                                            <div className='creneau_liste'>
                                                {activeOffre === true ?
                                                    <div>
                                                        {OffreNombrePersnne()}
                                                    </div>
                                                    :
                                                    <div>
                                                        {nombrePersonneView()}
                                                    </div>
                                                }


                                            </div>
                                            {parseInt(nombreParJour) > 10 ?
                                                <>
                                                    <p className='mt-2'>Plus de 10 personnes, choisissez ici : </p>
                                                    <div className='d-flex justify-content-center'>
                                                        <Select
                                                            placeholder="Personne ..."
                                                            onChange={(e) => setNombrePersonnePrise(e.value)}
                                                            options={nombre} />
                                                    </div>
                                                </>
                                                : ''}

                                        </div>
                                        : ''}
                                </div>
                            </div>
                        </div>
                        <p className="version">Version 1</p>
                    </div>
                  
                </div>
                
            </div>
        </div>
    )
}

export default ReserverSansCritere